import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { UploadSvg } from './svgs';

export const IconUpload: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={UploadSvg} viewBox="0 0 24 24" {...props} />;
};
